import * as React from 'react';
import { i as invariantIntlContext } from '../utils-DQtb17Bq-C4NqAcVV.js';
import { C as Context } from './injectIntl-BtqeBzQq-DKO65rGD.js';

function useIntl() {
  var intl = React.useContext(Context);
  invariantIntlContext(intl);
  return intl;
}

export { useIntl as u };
//# sourceMappingURL=useIntl-voJ4yxcS-DU7lWLPF.js.map
